/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

import ActionModel from 'cio/models/action';
import TemplateModel from 'cio/models/template';

type PreviewColumns = string[];
type PreviewerArgs = {
  action: ActionModel;
  template: TemplateModel;
  preview: { data: Record<string, any>[] };
  isRefreshing: boolean;
  visibleColumns: string[];
  updatePreviewColumns: (columns: PreviewColumns) => void;
  hasReadOnlyPermission: boolean;
};

export default class Previewer extends Component<PreviewerArgs> {
  @tracked selectedPreviewTab: 'table' | 'raw' = 'table';
  @tracked showColumnsModal = false;

  previewTabs = [
    {
      label: 'Table',
      value: 'table',
    },
    {
      label: 'Raw Data',
      value: 'raw',
    },
  ];

  get collectionSchema() {
    return this.args.action.get('collection').get('schema') ?? [];
  }

  @action
  updateColumns(columns: PreviewColumns) {
    this.showColumnsModal = false;
    this.args.updatePreviewColumns(columns);
  }
}
